import React from 'react';
import {
	GlobalSideNavigation,
	GlobalSideNavigationDataProvider,
} from '@atlassian/global-side-navigation';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useActivationId } from '@atlassian/jira-tenant-context-controller/src/components/activation-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { JiraWorkspaceAri } from '@atlassian/ari/jira/workspace';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import type { SidebarId } from '@atlassian/jira-route-types/src/Navigation.tsx';

type Props = {
	sidebarId: SidebarId;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GSNForOtherSidebars({ sidebarId }: Props) {
	/*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/

	const cloudId = useCloudId();
	const activationId = useActivationId();
	const userId: string | null = useAccountId();

	const entityAri = JiraWorkspaceAri.create({ siteId: cloudId, activationId }).toString();
	const ownerAri = (userId && IdentityUserAri.create({ userId }).toString()) || '';

	return (
		<GlobalSideNavigationDataProvider entityAri={entityAri} ownerAri={ownerAri}>
			{({ queryRef }) => (
				<GlobalSideNavigation
					testId="nav-platform-integration-sidebar.ui.jira-other-sidebars"
					queryRef={queryRef}
					app="jira"
					items={{}}
					forYou={{
						forYouUrl: '/for-you',
						useRecentItems: () => [],
						viewAllRecentsUrl: '/recents',
						useStarredItems() {
							return [];
						},
						viewAllStarredUrl: '/starred',
					}}
				/>
			)}
		</GlobalSideNavigationDataProvider>
	);
}
